export const expandWildWinObj = {
  0: 'wildWeedUp',
  1: 'wildWeedCender',
  2: 'wildWeedDw',
};

export const wildIdleAnimationNames = {
  0: 'idleBigUp',
  1: 'idleBig',
  2: 'idleBigDw',
};
